import { apiAction } from 'actions/application'

import { getSearchedLineNote } from 'services/lineNoteReader'

export const REQUESTING_SEARCHED_LINE_NOTE = 'REQUESTING_SEARCHED_LINE_NOTE'
export const SUCCESS_SEARCHED_LINE_NOTE = 'SUCCESS_SEARCHED_LINE_NOTE'
export const FAILURE_SEARCHED_LINE_NOTE = 'FAILURE_SEARCHED_LINE_NOTE'
export const CLEAR_LINE_NOTE_READER = 'CLEAR_LINE_NOTE_READER'

export const fetchSearchedLineNote = (searchedString, generation) =>
  apiAction({
    asyncFn: getSearchedLineNote,
    args: { searchedString, generation },
    requestActionType: REQUESTING_SEARCHED_LINE_NOTE,
    successActionType: SUCCESS_SEARCHED_LINE_NOTE,
    failureActionType: FAILURE_SEARCHED_LINE_NOTE,
    id: `${searchedString}:${generation}`,
  })

export const clearLineNoteReader = () => ({ type: CLEAR_LINE_NOTE_READER })
